import React from 'react';
import { ChevronDown } from 'lucide-react';

// 美国州代码到中文名称的映射
const stateMapping = {
  'AL': '亚拉巴马州',
  'AK': '阿拉斯加州', 
  'AS': '美属萨摩亚',
  'AZ': '亚利桑那州',
  'AR': '阿肯色州',
  'CA': '加利福尼亚州',
  'CO': '科罗拉多州',
  'CT': '康涅狄格州',
  'DE': '特拉华州',
  'DC': '华盛顿哥伦比亚特区',
  'FL': '佛罗里达州',
  'GA': '佐治亚州',
  'GU': '关岛',
  'HI': '夏威夷州',
  'ID': '爱达荷州',
  'IL': '伊利诺伊州',
  'IN': '印第安纳州',
  'IA': '爱荷华州',
  'KS': '堪萨斯州',
  'KY': '肯塔基州',
  'LA': '路易斯安那州',
  'ME': '缅因州',
  'MD': '马里兰州',
  'MA': '马萨诸塞州',
  'MI': '密歇根州',
  'MN': '明尼苏达州',
  'MS': '密西西比州',
  'MO': '密苏里州',
  'MT': '蒙大拿州',
  'NE': '内布拉斯加州',
  'NV': '内华达州',
  'NH': '新罕布什尔州',
  'NJ': '新泽西州',
  'NM': '新墨西哥州',
  'NY': '纽约州',
  'NC': '北卡罗来纳州',
  'ND': '北达科他州',
  'MP': '北马里亚纳群岛',
  'OH': '俄亥俄州',
  'OK': '俄克拉荷马州',
  'OR': '俄勒冈州',
  'PA': '宾夕法尼亚州',
  'PR': '波多黎各',
  'RI': '罗德岛州',
  'SC': '南卡罗来纳州',
  'SD': '南达科他州',
  'TN': '田纳西州',
  'TX': '得克萨斯州',
  'UT': '犹他州',
  'VT': '佛蒙特州',
  'VI': '美属维尔京群岛',
  'VA': '弗吉尼亚州',
  'WA': '华盛顿州',
  'WV': '西弗吉尼亚州',
  'WI': '威斯康星州',
  'WY': '怀俄明州'
};

// 美国州和领土完整列表
const US_STATES = [
  { value: 'AL', label: 'ALABAMA' },
  { value: 'AK', label: 'ALASKA' },
  { value: 'AS', label: 'AMERICAN SAMOA' },
  { value: 'AZ', label: 'ARIZONA' },
  { value: 'AR', label: 'ARKANSAS' },
  { value: 'CA', label: 'CALIFORNIA' },
  { value: 'CO', label: 'COLORADO' },
  { value: 'CT', label: 'CONNECTICUT' },
  { value: 'DE', label: 'DELAWARE' },
  { value: 'DC', label: 'DISTRICT OF COLUMBIA' },
  { value: 'FL', label: 'FLORIDA' },
  { value: 'GA', label: 'GEORGIA' },
  { value: 'GU', label: 'GUAM' },
  { value: 'HI', label: 'HAWAII' },
  { value: 'ID', label: 'IDAHO' },
  { value: 'IL', label: 'ILLINOIS' },
  { value: 'IN', label: 'INDIANA' },
  { value: 'IA', label: 'IOWA' },
  { value: 'KS', label: 'KANSAS' },
  { value: 'KY', label: 'KENTUCKY' },
  { value: 'LA', label: 'LOUISIANA' },
  { value: 'ME', label: 'MAINE' },
  { value: 'MD', label: 'MARYLAND' },
  { value: 'MA', label: 'MASSACHUSETTS' },
  { value: 'MI', label: 'MICHIGAN' },
  { value: 'MN', label: 'MINNESOTA' },
  { value: 'MS', label: 'MISSISSIPPI' },
  { value: 'MO', label: 'MISSOURI' },
  { value: 'MT', label: 'MONTANA' },
  { value: 'NE', label: 'NEBRASKA' },
  { value: 'NV', label: 'NEVADA' },
  { value: 'NH', label: 'NEW HAMPSHIRE' },
  { value: 'NJ', label: 'NEW JERSEY' },
  { value: 'NM', label: 'NEW MEXICO' },
  { value: 'NY', label: 'NEW YORK' },
  { value: 'NC', label: 'NORTH CAROLINA' },
  { value: 'ND', label: 'NORTH DAKOTA' },
  { value: 'MP', label: 'NORTHERN MARIANA ISLANDS' },
  { value: 'OH', label: 'OHIO' },
  { value: 'OK', label: 'OKLAHOMA' },
  { value: 'OR', label: 'OREGON' },
  { value: 'PA', label: 'PENNSYLVANIA' },
  { value: 'PR', label: 'PUERTO RICO' },
  { value: 'RI', label: 'RHODE ISLAND' },
  { value: 'SC', label: 'SOUTH CAROLINA' },
  { value: 'SD', label: 'SOUTH DAKOTA' },
  { value: 'TN', label: 'TENNESSEE' },
  { value: 'TX', label: 'TEXAS' },
  { value: 'UT', label: 'UTAH' },
  { value: 'VT', label: 'VERMONT' },
  { value: 'VI', label: 'VIRGIN ISLANDS' },
  { value: 'VA', label: 'VIRGINIA' },
  { value: 'WA', label: 'WASHINGTON' },
  { value: 'WV', label: 'WEST VIRGINIA' },
  { value: 'WI', label: 'WISCONSIN' },
  { value: 'WY', label: 'WYOMING' }
];

// 获取州中文名称
export const getStateName = (stateCode) => {
  return stateMapping[stateCode] || stateCode;
};

const USStateSelect = ({ label, value, onChange, required = false, className = '' }) => {
  return (
    <div className={className}>
      <label className="block text-sm font-medium text-gray-700 mb-2">
        {label} {required && <span className="text-red-500">*</span>}
      </label>
      <div className="relative">
        <select
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="w-full h-12 px-4 py-3 pr-10 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent bg-gradient-to-r from-white to-purple-50 shadow-sm hover:shadow-md transition-all duration-200 appearance-none cursor-pointer"
        >
          <option value="">- 选择州 -</option>
          {US_STATES.map(state => (
            <option key={state.value} value={state.value}>
              {state.value} - {stateMapping[state.value]} ({state.label})
            </option>
          ))}
        </select>
        <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
          <ChevronDown className="h-4 w-4 text-gray-400" />
        </div>
      </div>
      {value && (
        <p className="text-xs text-gray-500 mt-1">
          已选择: {getStateName(value)}
        </p>
      )}
    </div>
  );
};

export default USStateSelect; 